"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderAccessAuthGuardService = void 0;
const router_1 = require("@angular/router");
const of_1 = require("rxjs/internal/observable/of");
const operators_1 = require("rxjs/operators");
const orderStatus_service_1 = require("./orderStatus.service");
/**
 * Order Access Auth Guard Service
 *
 * Checks if the user has the access to activate component
 */
class OrderAccessAuthGuardService {
    constructor(orderService) {
        this.orderService = orderService;
    }
    canActivate(route, state) {
        // dynamically handling the route on the basis of allowed roles
        return this.orderService.getLoginStatus().pipe(operators_1.map((res) => {
            if (res.securityStatus === 4) {
                this.redirectToDashboard(res);
            }
            else {
                return true;
            }
        }), operators_1.catchError(() => {
            location.href = '/my_account/personal/#/wireless/orders/history';
            return of_1.of(false);
        }));
    }
    redirectToDashboard(status) {
        if (status.businessAccount) {
            location.href = '/my_account/personal/#/business/orders/history';
        }
        else if (status.prepaidAccount) {
            location.href = '/my_account/personal/#/prepaid/orders/history';
        }
        else {
            location.href = '/my_account/personal/#/wireless/orders/history';
        }
    }
}
exports.OrderAccessAuthGuardService = OrderAccessAuthGuardService;
//# sourceMappingURL=orderaccessauth.service.js.map